// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".memberBodyWrapper {\n  background-color: #e8eef7;\n  padding: 60px 0px 0px 0px;\n  margin-top: 24px;\n  border-radius: 32px 32px 0px 0px;\n}", ""]);
// Exports
module.exports = exports;
